import React, { useEffect, useState } from "react";
import BreadCrumbComponent from "../Misc/BreadCrumb/BreadCrumbComponent";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ProductCardPriceInfo } from "../../../utils/AppUtils";
import useLogin from "../../../custom-hooks/useLogin";
import { getEnrollBrokerSession } from "../../../redux/certified/actions";
import {
  clickStreamUser,
  SessionKeys,
  convertTimeFormat,
  getProcureInfo,
  formatStartDateTime,
  formatEndDateTime,
  isSessionWithinOneHour,
} from "../../../utils/AppUtils";
import CONFIG from "../../../utils/config";
import API_LIST from "../../../utils/apiList";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import Dropdown from "react-bootstrap/Dropdown";
import ErrorSectionSidebar from "../../ErrorPage/ErrorSectionSideBar";
import CartPopUpComponent from "../DetailPage/CartPopUp/CartPopUpComponent";
import ConfirmModal from "../../modal/ConfirmModal";
import {
  coachingDetail,
  coachingDetailClear,
} from "../../../redux/provider/actions";
import Page from "../../Page";
import { postLikeDisLikeProduct } from "../../../redux/discuss/actions";
import { isAndroid, isIOS } from "react-device-detect";
import RightPanelComponent from "../DetailPage/DetailPageRightPanel/RightPanelComponent";
import RecommendationEngineSection from "../../b2cComponents/RecommendationEngineSection";
import RecommendationEnginePage from "../../../pages/B2C-Pages/RecommendationEnginePage";
import SimilarCoachings from "./SimilarCoachings";
import { routeList } from "../../../utils/routeList";
import { getActiveHeader } from "../../../redux/home/actions";
import { useTranslation } from "react-i18next";
function CoachingDetailPage({ isMobile }) {
  const { state } = useLocation();
  console.log("banner--", state?.banner);
  useEffect(() => {
    console.log("banner---", state?.title);
    setTitle(state?.title);
  }, []);
  const { t } = useTranslation();
  let banner = state?.banner;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  // const serviceCode = params.get("service_code");
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      if (_.isEmpty(provider_name)) {
        dispatch(getActiveHeader("learn"));
      }
    }, 1000);
  }, []);

  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  const serviceCode = paramsReq.service_code;
  const provider_name = paramsReq.provider_name;
  const provider_id = paramsReq.provider_id;

  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");

  const [bannerPriceInfo, setBannerPriceInfo] = useState({ isFree: true });

  const [infoModal, setInfoModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [breadCrumbData, setBreadCrumbData] = useState([
    {
      name: provider_name ? "Partners" : t("learn"),
      active: false,
      link: "",
      isLoading: false,
    },
    {
      name: t("coaching"),
      active: false,
      link: "/learn/coaching",
      isLoading: false,
    },
    { name: "-", active: false, link: "", isLoading: true },
  ]);

  const [showInfoModalMsg, setShowInfoModalMsg] = useState("");

  const setTitleData = (title) => {
    console.log("title", title);
    setTitle(title);
    let paramsReq = {
      provider_id: provider_id,
      provider_name: provider_name,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let breadCrumb = [
      {
        name: provider_name ? "Partners" : t("learn"),
        active: false,
        link: isMobile
          ? ""
          : provider_name
          ? "/our-partners"
          : routeList.LEARN_COURSES_PAGE,
        isLoading: false,
      },
    ];
    if (provider_name) {
      breadCrumb.push({
        name: provider_name,
        active: false,
        link: isMobile ? "" : `/partner-detail?c=${encodedUrl}`,
        isLoading: false,
      });
    }
    breadCrumb.push({
      name: t("coaching"),
      active: false,
      link: isMobile
        ? ""
        : provider_id
        ? `/partner-detail/coaching/?c=${encodedUrl}`
        : "/learn/coaching",
      isLoading: false,
    });
    breadCrumb.push({ name: title, active: true, link: "", isLoading: false });
    // setBreadCrumbData([
    //   {
    //     name: provider_name ? "Partners" : "Learn",
    //     active: false,
    //     link: provider_name ? "/our-partners" : "/learn/courses?tab=1",
    //     isLoading: false,
    //   },
    //   {
    //     name: "Coaching",
    //     active: false,
    //     link: "/learn/coaching",
    //     isLoading: false,
    //   },
    //   { name: title, active: true, link: "", isLoading: false },
    // ]);
    setBreadCrumbData(breadCrumb);
  };

  const singlePriceUpcoming = () => {
    console.log(bannerPriceInfo);
    if (_.isEmpty(bannerPriceInfo) || bannerPriceInfo.is_paid) {
      return <></>;
    }
    bannerPriceInfo.textColor = coachingDetailData?.is_paid
      ? "#FCBEF9"
      : bannerPriceInfo.textColor;
    return ProductCardPriceInfo(
      bannerPriceInfo.showText,
      bannerPriceInfo.textColor
    );
  };

  const coachingDetailResponse = useSelector(
    (state) => state.provider.coachingDetail
  );
  const [coachingDetailData, setCoachingDetailData] = useState();
  console.log("co---", coachingDetailResponse);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      coachingDetail({
        module: "coachingDetail",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          service_code: serviceCode,
          activeLanguage: activeLanguage ? activeLanguage : "",
        },
      })
    );
    return () => {
      dispatch(coachingDetailClear());
    };
  }, [serviceCode, activeLanguage]);

  useEffect(() => {
    if (!_.isEmpty(coachingDetailResponse)) {
      if (coachingDetailResponse?.status === "success") {
        const listData = coachingDetailResponse?.payload?.payload;
        console.log("listdate", listData);
        setTitleData(listData[0]?.product_name);
        setCoachingDetailData(listData[0]);

        let priceInfo1 = getProcureInfo(listData[0]?.purchased_info);

        setBannerPriceInfo(priceInfo1);
        setIsLoading(false);
      } else {
        setCoachingDetailData();
        setIsLoading(false);
      }
    }
  }, [coachingDetailResponse]);

  const [headerProdData, setHeaderProdData] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  const proceedToPurchase = (coachingDetailData, priceInfo1) => {
    let tags = [];
    let logoURL = "";
    if (!_.isEmpty(coachingDetailData.provider)) {
      tags.push(coachingDetailData.provider.provider_display_name);
      logoURL = coachingDetailData.provider.provider_img;
    }

    tags.push("Coaching");
    tags.push(coachingDetailData.is_recurring ? "Subscription" : "One Time");

    let priceInfo = _.cloneDeep(priceInfo1);
    priceInfo.isAddToCart = coachingDetailData.is_addtocart;
    setIsOpen(true);
    setHeaderProdData({
      id: coachingDetailData?.product_id,
      title: coachingDetailData.product_name,
      logoURL: logoURL,
      logoAltText: "ED",
      bannerURL: coachingDetailData?.product_thumbnail,
      tagsArray: tags,
      description: coachingDetailData?.short_description,
      duration: "",
      view: "",
      price: priceInfo.price,
      isPaid: priceInfo.isPurchased,
      priceInfo: priceInfo,
      productType: "subscription-product",
      priceType: coachingDetailData.payment_frequency,
    });
  };

  const [isLikeClicked, setIsLikeClicked] = useState(false);
  const [isBookMarkClicked, setIsBookMarkClicked] = useState(false);

  useEffect(() => {
    setIsLikeClicked(coachingDetailData?.is_like);
    setIsBookMarkClicked(coachingDetailData?.is_like);
  }, [coachingDetailData]);

  useEffect(() => {
    console.log("islike--after");
  }, [isLikeClicked]);

  useEffect(() => {
    console.log("isbookmark--after");
  }, [isBookMarkClicked]);

  const postBookmark = () => {
    setIsBookMarkClicked(!isBookMarkClicked);
  };

  const postLikeDisLike = () => {
    console.log("like--", isLikeClicked);
    setIsLikeClicked(!isLikeClicked);
    dispatch(
      postLikeDisLikeProduct({
        URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LIKE_DISLIKE_PRODUCT}`,
        method: "post",
        isJSON: true,
        payload: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          entity_id: coachingDetailData?.product_id,
          entity_type: coachingDetailData?.product_type,
          origin: coachingDetailData?.source,
          like: !coachingDetailData?.is_like,
        },
      })
    );
  };

  return (
    <>
      {isMobile ? (
        <section className="bannersection-sec">
          <div className="bannersection bgba">
            {/* <div className="bannerrimg"> */}
            <div
              className={` ${
                coachingDetailData?.banner
                  ? "bannerrimg"
                  : "title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center"
              }`}
            >
              {/* <div className="title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center"> */}
              {isLoading ? (
                <ShimmerScreen case={"rect"} width={"100%"} height={"358px"} />
              ) : coachingDetailData?.banner ? (
                <img src={coachingDetailData?.banner} alt="banner-img" />
              ) : (
                <p
                  dangerouslySetInnerHTML={{
                    __html: title,
                  }}
                ></p>
              )}
            </div>
            {/* </div> */}
            <div className="bb-sec">
              <div className="container d-flex align-items-center cont-baner">
                <div className="button-box">
                  {isLoading ? (
                    ""
                  ) : (
                    <>
                      <span>{singlePriceUpcoming()}</span>
                      {coachingDetailData &&
                        !coachingDetailData?.is_paid &&
                        !coachingDetailData?.purchased_info
                          ?.part_of_subscription && (
                          <button
                            type="button"
                            className="startcourse-btn"
                            onClick={() => {
                              if (isAndroid || isIOS) {
                                try {
                                  let obj = {
                                    message: "click-on-purchase",
                                    productId: coachingDetailData?.product_id,
                                    amount: bannerPriceInfo?.price,
                                    title: title,
                                    provider_name:
                                      coachingDetailData.provider
                                        .provider_display_name,
                                    provider_img:
                                      coachingDetailData.provider.provider_img,
                                    enrolledtextAmount:
                                      coachingDetailData?.purchased_info
                                        ?.enrolled_text,
                                  };
                                  if (window.callbackHandler != undefined) {
                                    window.callbackHandler.postMessage(
                                      JSON.stringify(obj)
                                    );
                                  }
                                  if (window.webkit != undefined) {
                                    if (
                                      window.webkit.messageHandlers
                                        .callbackHandler != undefined
                                    ) {
                                      window.webkit.messageHandlers.callbackHandler.postMessage(
                                        JSON.stringify(obj)
                                      );
                                    }
                                  }
                                } catch (err) {
                                  console.log("error in sending message");
                                }
                              }
                              proceedToPurchase(
                                coachingDetailData,
                                bannerPriceInfo
                              );
                            }}
                          >
                            {t("Purchase")}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#415385"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        )}
                    </>
                  )}
                </div>

                {false && (
                  <div className="bannershare-btn">
                    <Dropdown className="customdropdown-btn">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <path
                            d="M30 36.6666C28.6111 36.6666 27.4306 36.1805 26.4583 35.2083C25.4861 34.236 25 33.0555 25 31.6666C25 31.4721 25.0139 31.2708 25.0417 31.0624C25.0694 30.8541 25.1111 30.6666 25.1667 30.4999L13.4167 23.6666C12.9444 24.0833 12.4167 24.4096 11.8333 24.6458C11.25 24.8819 10.6389 24.9999 10 24.9999C8.61111 24.9999 7.43056 24.5138 6.45833 23.5416C5.48611 22.5694 5 21.3888 5 19.9999C5 18.611 5.48611 17.4305 6.45833 16.4583C7.43056 15.486 8.61111 14.9999 10 14.9999C10.6389 14.9999 11.25 15.118 11.8333 15.3541C12.4167 15.5902 12.9444 15.9166 13.4167 16.3333L25.1667 9.49992C25.1111 9.33325 25.0694 9.14575 25.0417 8.93742C25.0139 8.72908 25 8.5277 25 8.33325C25 6.94436 25.4861 5.76381 26.4583 4.79159C27.4306 3.81936 28.6111 3.33325 30 3.33325C31.3889 3.33325 32.5694 3.81936 33.5417 4.79159C34.5139 5.76381 35 6.94436 35 8.33325C35 9.72214 34.5139 10.9027 33.5417 11.8749C32.5694 12.8471 31.3889 13.3333 30 13.3333C29.3611 13.3333 28.75 13.2152 28.1667 12.9791C27.5833 12.743 27.0556 12.4166 26.5833 11.9999L14.8333 18.8333C14.8889 18.9999 14.9306 19.1874 14.9583 19.3958C14.9861 19.6041 15 19.8055 15 19.9999C15 20.1944 14.9861 20.3958 14.9583 20.6041C14.9306 20.8124 14.8889 20.9999 14.8333 21.1666L26.5833 27.9999C27.0556 27.5833 27.5833 27.2569 28.1667 27.0208C28.75 26.7846 29.3611 26.6666 30 26.6666C31.3889 26.6666 32.5694 27.1527 33.5417 28.1249C34.5139 29.0971 35 30.2777 35 31.6666C35 33.0555 34.5139 34.236 33.5417 35.2083C32.5694 36.1805 31.3889 36.6666 30 36.6666ZM30 9.99992C30.4722 9.99992 30.8681 9.8402 31.1875 9.52075C31.5069 9.20131 31.6667 8.80547 31.6667 8.33325C31.6667 7.86103 31.5069 7.4652 31.1875 7.14575C30.8681 6.82631 30.4722 6.66658 30 6.66658C29.5278 6.66658 29.1319 6.82631 28.8125 7.14575C28.4931 7.4652 28.3333 7.86103 28.3333 8.33325C28.3333 8.80547 28.4931 9.20131 28.8125 9.52075C29.1319 9.8402 29.5278 9.99992 30 9.99992ZM10 21.6666C10.4722 21.6666 10.8681 21.5069 11.1875 21.1874C11.5069 20.868 11.6667 20.4721 11.6667 19.9999C11.6667 19.5277 11.5069 19.1319 11.1875 18.8124C10.8681 18.493 10.4722 18.3333 10 18.3333C9.52778 18.3333 9.13194 18.493 8.8125 18.8124C8.49306 19.1319 8.33333 19.5277 8.33333 19.9999C8.33333 20.4721 8.49306 20.868 8.8125 21.1874C9.13194 21.5069 9.52778 21.6666 10 21.6666ZM30 33.3333C30.4722 33.3333 30.8681 33.1735 31.1875 32.8541C31.5069 32.5346 31.6667 32.1388 31.6667 31.6666C31.6667 31.1944 31.5069 30.7985 31.1875 30.4791C30.8681 30.1596 30.4722 29.9999 30 29.9999C29.5278 29.9999 29.1319 30.1596 28.8125 30.4791C28.4931 30.7985 28.3333 31.1944 28.3333 31.6666C28.3333 32.1388 28.4931 32.5346 28.8125 32.8541C29.1319 33.1735 29.5278 33.3333 30 33.3333Z"
                            fill="white"
                          />
                        </svg>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <div
                          className={`list-drop reset-btn like-btn d-flex ${
                            isLikeClicked ? "active" : ""
                          }`}
                          onClick={() => postLikeDisLike()}
                        >
                          {isLikeClicked ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 512 512"
                            >
                              <path
                                fill="#ff2600"
                                d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M12 21L10.55 19.7C8.86667 18.1833 7.475 16.875 6.375 15.775C5.275 14.675 4.4 13.6875 3.75 12.8125C3.1 11.9375 2.64583 11.1333 2.3875 10.4C2.12917 9.66666 2 8.91666 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.36667 2.64999 9.19167 2.83333 9.975 3.19999C10.7583 3.56666 11.4333 4.08333 12 4.74999C12.5667 4.08333 13.2417 3.56666 14.025 3.19999C14.8083 2.83333 15.6333 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 8.91666 21.8708 9.66666 21.6125 10.4C21.3542 11.1333 20.9 11.9375 20.25 12.8125C19.6 13.6875 18.725 14.675 17.625 15.775C16.525 16.875 15.1333 18.1833 13.45 19.7L12 21ZM12 18.3C13.6 16.8667 14.9167 15.6375 15.95 14.6125C16.9833 13.5875 17.8 12.6958 18.4 11.9375C19 11.1792 19.4167 10.5042 19.65 9.91249C19.8833 9.32083 20 8.73333 20 8.14999C20 7.14999 19.6667 6.31666 19 5.64999C18.3333 4.98333 17.5 4.64999 16.5 4.64999C15.7167 4.64999 14.9917 4.87083 14.325 5.31249C13.6583 5.75416 13.2 6.31666 12.95 6.99999H11.05C10.8 6.31666 10.3417 5.75416 9.675 5.31249C9.00833 4.87083 8.28333 4.64999 7.5 4.64999C6.5 4.64999 5.66667 4.98333 5 5.64999C4.33333 6.31666 4 7.14999 4 8.14999C4 8.73333 4.11667 9.32083 4.35 9.91249C4.58333 10.5042 5 11.1792 5.6 11.9375C6.2 12.6958 7.01667 13.5875 8.05 14.6125C9.08333 15.6375 10.4 16.8667 12 18.3Z"
                                fill="black"
                              />
                            </svg>
                          )}
                          Like
                        </div>
                        <div className="list-drop">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7625 15.025 18.6375C15.0417 18.5125 15.0667 18.4 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.6458 7.1 14.7875C6.75 14.9292 6.38333 15 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.07083 7.1 9.2125C7.45 9.35417 7.76667 9.55 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.4875 15.025 5.3625C15.0083 5.2375 15 5.11667 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92917 16.9 7.7875C16.55 7.64583 16.2333 7.45 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5125 8.975 11.6375C8.99167 11.7625 9 11.8833 9 12C9 12.1167 8.99167 12.2375 8.975 12.3625C8.95833 12.4875 8.93333 12.6 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3542 16.9 16.2125C17.25 16.0708 17.6167 16 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22ZM18 6C18.2833 6 18.5208 5.90417 18.7125 5.7125C18.9042 5.52083 19 5.28333 19 5C19 4.71667 18.9042 4.47917 18.7125 4.2875C18.5208 4.09583 18.2833 4 18 4C17.7167 4 17.4792 4.09583 17.2875 4.2875C17.0958 4.47917 17 4.71667 17 5C17 5.28333 17.0958 5.52083 17.2875 5.7125C17.4792 5.90417 17.7167 6 18 6ZM6 13C6.28333 13 6.52083 12.9042 6.7125 12.7125C6.90417 12.5208 7 12.2833 7 12C7 11.7167 6.90417 11.4792 6.7125 11.2875C6.52083 11.0958 6.28333 11 6 11C5.71667 11 5.47917 11.0958 5.2875 11.2875C5.09583 11.4792 5 11.7167 5 12C5 12.2833 5.09583 12.5208 5.2875 12.7125C5.47917 12.9042 5.71667 13 6 13ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19C19 18.7167 18.9042 18.4792 18.7125 18.2875C18.5208 18.0958 18.2833 18 18 18C17.7167 18 17.4792 18.0958 17.2875 18.2875C17.0958 18.4792 17 18.7167 17 19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20Z"
                              fill="black"
                            />
                          </svg>{" "}
                          Share
                        </div>
                        <div className="">
                          <button
                            className={`list-drop reset-btn like-btn d-flex ${
                              isBookMarkClicked ? "active" : ""
                            }`}
                            onClick={() => postBookmark()}
                          >
                            {isBookMarkClicked ? (
                              <svg
                                width="24"
                                height="26"
                                viewBox="-6 -2 22 22"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g
                                  id="Page-1"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fill-rule="evenodd"
                                >
                                  <g
                                    id="Dribbble-Light-Preview"
                                    transform="translate(-305.000000, -2679.000000)"
                                    strokeWidth="2"
                                    stroke="#ff9800"
                                    fill="#ff9800"
                                  >
                                    <g
                                      id="icons"
                                      transform="translate(56.000000, 160.000000)"
                                    >
                                      <polygon
                                        id="bookmark_fill-[#1226]"
                                        points="259 2519 259 2539 254 2534 249 2539 249 2519"
                                      ></polygon>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            ) : (
                              <svg
                                width="24"
                                height="26"
                                viewBox="-6 -2 22 22"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g
                                  id="Page-1"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fill-rule="evenodd"
                                >
                                  <g
                                    id="Dribbble-Light-Preview"
                                    transform="translate(-305.000000, -2679.000000)"
                                    strokeWidth="2"
                                    stroke="black"
                                    fill="none"
                                  >
                                    <g
                                      id="icons"
                                      transform="translate(56.000000, 160.000000)"
                                    >
                                      <polygon
                                        id="bookmark_fill-[#1226]"
                                        points="259 2519 259 2539 254 2534 249 2539 249 2519"
                                      ></polygon>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            )}
                            Bookmark
                          </button>
                        </div>
                        <div className="list-drop">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                              fill="black"
                            />
                          </svg>{" "}
                          Save to Wishlist
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <BreadCrumbComponent crumbList={breadCrumbData} />
              </div>
              <div className="col-md-8">
                <div className="module-learn-text mt-0">
                  {isLoading ? (
                    <div className="mgt30">
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"50px"}
                      />
                    </div>
                  ) : (
                    <h2 className="mgt30">{title}</h2>
                  )}

                  {isLoading ? (
                    <ul className="learncourselistt-row mt-3 mb-3">
                      <li>
                        <ShimmerScreen
                          case={"rect"}
                          width={"80px"}
                          height={"25px"}
                        />
                      </li>
                      <li>
                        <ShimmerScreen
                          case={"rect"}
                          width={"80px"}
                          height={"25px"}
                        />
                      </li>
                    </ul>
                  ) : (
                    coachingDetailData && (
                      <div className="d-flex box-meta">
                        <div className="img-box-meta">
                          <img
                            src={
                              coachingDetailData.provider
                                ? coachingDetailData.provider.provider_img
                                : ""
                            }
                          />
                        </div>
                        <div className="meta-lsit">
                          <ul className="learncourselistt-row">
                            <li>
                              {coachingDetailData.provider
                                ? coachingDetailData.provider
                                    .provider_display_name
                                : ""}{" "}
                              abd
                            </li>
                            <li>Coaching</li>
                            <li>
                              {_.toLower(
                                coachingDetailData?.payment_frequency
                              ) === "monthly"
                                ? "Subscription"
                                : "One Time"}
                            </li>
                          </ul>
                        </div>
                      </div>
                    )
                  )}

                  {isLoading ? (
                    <ShimmerScreen case="rect" width="60%" height="7rem" />
                  ) : (
                    <div
                      className="details-discription"
                      dangerouslySetInnerHTML={{
                        __html: coachingDetailData?.long_description,
                      }}
                    ></div>
                  )}

                  <CartPopUpComponent
                    isOpen={isOpen}
                    productData={headerProdData}
                    closeAction={() => setIsOpen(false)}
                    isSubscription={true}
                    setMainPageLoading={setInfoModal}
                    isMobile={isMobile}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <Page>
          <section className="bannersection-sec">
            <div className="bannersection bgba">
              <div
                className={` ${
                  coachingDetailData?.banner
                    ? "bannerrimg"
                    : "title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center"
                }`}
              >
                {/* <div className="title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center"> */}
                {isLoading ? (
                  <ShimmerScreen case={"rect"} width={"100%"} height={"358px"} />
                ) : coachingDetailData?.banner ? (
                  <img src={coachingDetailData?.banner} alt="banner-img" />
                ) : (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: title,
                    }}
                  ></p>
                )}
              </div>
              {/* </div> */}
              {!_.isEmpty(bannerPriceInfo?.showText)||(coachingDetailData &&
                          !coachingDetailData?.is_paid &&
                          !coachingDetailData?.purchased_info
                            ?.part_of_subscription )?<div className="bb-sec">

                <div className="container d-flex align-items-center cont-baner">
                  <div className="button-box">
                    {isLoading ? (
                      ""
                    ) : (
                      <>
                        <span>{singlePriceUpcoming()}</span>
                        {coachingDetailData &&
                          !coachingDetailData?.is_paid &&
                          !coachingDetailData?.purchased_info
                            ?.part_of_subscription && (
                            <button
                              type="button"
                              className="startcourse-btn"
                              onClick={() =>
                                proceedToPurchase(
                                  coachingDetailData,
                                  bannerPriceInfo
                                )
                              }
                            >
                              {t("Purchase")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                  stroke="#415385"
                                  strokeWidth="1.66667"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                          )}
                      </>
                    )}
                  </div>

                  {false && (
                    <div className="bannershare-btn">
                      <Dropdown className="customdropdown-btn">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M30 36.6666C28.6111 36.6666 27.4306 36.1805 26.4583 35.2083C25.4861 34.236 25 33.0555 25 31.6666C25 31.4721 25.0139 31.2708 25.0417 31.0624C25.0694 30.8541 25.1111 30.6666 25.1667 30.4999L13.4167 23.6666C12.9444 24.0833 12.4167 24.4096 11.8333 24.6458C11.25 24.8819 10.6389 24.9999 10 24.9999C8.61111 24.9999 7.43056 24.5138 6.45833 23.5416C5.48611 22.5694 5 21.3888 5 19.9999C5 18.611 5.48611 17.4305 6.45833 16.4583C7.43056 15.486 8.61111 14.9999 10 14.9999C10.6389 14.9999 11.25 15.118 11.8333 15.3541C12.4167 15.5902 12.9444 15.9166 13.4167 16.3333L25.1667 9.49992C25.1111 9.33325 25.0694 9.14575 25.0417 8.93742C25.0139 8.72908 25 8.5277 25 8.33325C25 6.94436 25.4861 5.76381 26.4583 4.79159C27.4306 3.81936 28.6111 3.33325 30 3.33325C31.3889 3.33325 32.5694 3.81936 33.5417 4.79159C34.5139 5.76381 35 6.94436 35 8.33325C35 9.72214 34.5139 10.9027 33.5417 11.8749C32.5694 12.8471 31.3889 13.3333 30 13.3333C29.3611 13.3333 28.75 13.2152 28.1667 12.9791C27.5833 12.743 27.0556 12.4166 26.5833 11.9999L14.8333 18.8333C14.8889 18.9999 14.9306 19.1874 14.9583 19.3958C14.9861 19.6041 15 19.8055 15 19.9999C15 20.1944 14.9861 20.3958 14.9583 20.6041C14.9306 20.8124 14.8889 20.9999 14.8333 21.1666L26.5833 27.9999C27.0556 27.5833 27.5833 27.2569 28.1667 27.0208C28.75 26.7846 29.3611 26.6666 30 26.6666C31.3889 26.6666 32.5694 27.1527 33.5417 28.1249C34.5139 29.0971 35 30.2777 35 31.6666C35 33.0555 34.5139 34.236 33.5417 35.2083C32.5694 36.1805 31.3889 36.6666 30 36.6666ZM30 9.99992C30.4722 9.99992 30.8681 9.8402 31.1875 9.52075C31.5069 9.20131 31.6667 8.80547 31.6667 8.33325C31.6667 7.86103 31.5069 7.4652 31.1875 7.14575C30.8681 6.82631 30.4722 6.66658 30 6.66658C29.5278 6.66658 29.1319 6.82631 28.8125 7.14575C28.4931 7.4652 28.3333 7.86103 28.3333 8.33325C28.3333 8.80547 28.4931 9.20131 28.8125 9.52075C29.1319 9.8402 29.5278 9.99992 30 9.99992ZM10 21.6666C10.4722 21.6666 10.8681 21.5069 11.1875 21.1874C11.5069 20.868 11.6667 20.4721 11.6667 19.9999C11.6667 19.5277 11.5069 19.1319 11.1875 18.8124C10.8681 18.493 10.4722 18.3333 10 18.3333C9.52778 18.3333 9.13194 18.493 8.8125 18.8124C8.49306 19.1319 8.33333 19.5277 8.33333 19.9999C8.33333 20.4721 8.49306 20.868 8.8125 21.1874C9.13194 21.5069 9.52778 21.6666 10 21.6666ZM30 33.3333C30.4722 33.3333 30.8681 33.1735 31.1875 32.8541C31.5069 32.5346 31.6667 32.1388 31.6667 31.6666C31.6667 31.1944 31.5069 30.7985 31.1875 30.4791C30.8681 30.1596 30.4722 29.9999 30 29.9999C29.5278 29.9999 29.1319 30.1596 28.8125 30.4791C28.4931 30.7985 28.3333 31.1944 28.3333 31.6666C28.3333 32.1388 28.4931 32.5346 28.8125 32.8541C29.1319 33.1735 29.5278 33.3333 30 33.3333Z"
                              fill="white"
                            />
                          </svg>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <div
                            className={`list-drop reset-btn like-btn d-flex ${
                              isLikeClicked ? "active" : ""
                            }`}
                            onClick={() => postLikeDisLike()}
                          >
                            {isLikeClicked ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 512 512"
                              >
                                <path
                                  fill="#ff2600"
                                  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M12 21L10.55 19.7C8.86667 18.1833 7.475 16.875 6.375 15.775C5.275 14.675 4.4 13.6875 3.75 12.8125C3.1 11.9375 2.64583 11.1333 2.3875 10.4C2.12917 9.66666 2 8.91666 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.36667 2.64999 9.19167 2.83333 9.975 3.19999C10.7583 3.56666 11.4333 4.08333 12 4.74999C12.5667 4.08333 13.2417 3.56666 14.025 3.19999C14.8083 2.83333 15.6333 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 8.91666 21.8708 9.66666 21.6125 10.4C21.3542 11.1333 20.9 11.9375 20.25 12.8125C19.6 13.6875 18.725 14.675 17.625 15.775C16.525 16.875 15.1333 18.1833 13.45 19.7L12 21ZM12 18.3C13.6 16.8667 14.9167 15.6375 15.95 14.6125C16.9833 13.5875 17.8 12.6958 18.4 11.9375C19 11.1792 19.4167 10.5042 19.65 9.91249C19.8833 9.32083 20 8.73333 20 8.14999C20 7.14999 19.6667 6.31666 19 5.64999C18.3333 4.98333 17.5 4.64999 16.5 4.64999C15.7167 4.64999 14.9917 4.87083 14.325 5.31249C13.6583 5.75416 13.2 6.31666 12.95 6.99999H11.05C10.8 6.31666 10.3417 5.75416 9.675 5.31249C9.00833 4.87083 8.28333 4.64999 7.5 4.64999C6.5 4.64999 5.66667 4.98333 5 5.64999C4.33333 6.31666 4 7.14999 4 8.14999C4 8.73333 4.11667 9.32083 4.35 9.91249C4.58333 10.5042 5 11.1792 5.6 11.9375C6.2 12.6958 7.01667 13.5875 8.05 14.6125C9.08333 15.6375 10.4 16.8667 12 18.3Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                            Like
                          </div>
                          <div className="list-drop">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7625 15.025 18.6375C15.0417 18.5125 15.0667 18.4 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.6458 7.1 14.7875C6.75 14.9292 6.38333 15 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.07083 7.1 9.2125C7.45 9.35417 7.76667 9.55 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.4875 15.025 5.3625C15.0083 5.2375 15 5.11667 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92917 16.9 7.7875C16.55 7.64583 16.2333 7.45 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5125 8.975 11.6375C8.99167 11.7625 9 11.8833 9 12C9 12.1167 8.99167 12.2375 8.975 12.3625C8.95833 12.4875 8.93333 12.6 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3542 16.9 16.2125C17.25 16.0708 17.6167 16 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22ZM18 6C18.2833 6 18.5208 5.90417 18.7125 5.7125C18.9042 5.52083 19 5.28333 19 5C19 4.71667 18.9042 4.47917 18.7125 4.2875C18.5208 4.09583 18.2833 4 18 4C17.7167 4 17.4792 4.09583 17.2875 4.2875C17.0958 4.47917 17 4.71667 17 5C17 5.28333 17.0958 5.52083 17.2875 5.7125C17.4792 5.90417 17.7167 6 18 6ZM6 13C6.28333 13 6.52083 12.9042 6.7125 12.7125C6.90417 12.5208 7 12.2833 7 12C7 11.7167 6.90417 11.4792 6.7125 11.2875C6.52083 11.0958 6.28333 11 6 11C5.71667 11 5.47917 11.0958 5.2875 11.2875C5.09583 11.4792 5 11.7167 5 12C5 12.2833 5.09583 12.5208 5.2875 12.7125C5.47917 12.9042 5.71667 13 6 13ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19C19 18.7167 18.9042 18.4792 18.7125 18.2875C18.5208 18.0958 18.2833 18 18 18C17.7167 18 17.4792 18.0958 17.2875 18.2875C17.0958 18.4792 17 18.7167 17 19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20Z"
                                fill="black"
                              />
                            </svg>{" "}
                            Share
                          </div>
                          <div className="">
                            <button
                              className={`list-drop reset-btn like-btn d-flex ${
                                isBookMarkClicked ? "active" : ""
                              }`}
                              onClick={() => postBookmark()}
                            >
                              {isBookMarkClicked ? (
                                <svg
                                  width="24"
                                  height="26"
                                  viewBox="-6 -2 22 22"
                                  version="1.1"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="Page-1"
                                    stroke="none"
                                    strokeWidth="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                  >
                                    <g
                                      id="Dribbble-Light-Preview"
                                      transform="translate(-305.000000, -2679.000000)"
                                      strokeWidth="2"
                                      stroke="#ff9800"
                                      fill="#ff9800"
                                    >
                                      <g
                                        id="icons"
                                        transform="translate(56.000000, 160.000000)"
                                      >
                                        <polygon
                                          id="bookmark_fill-[#1226]"
                                          points="259 2519 259 2539 254 2534 249 2539 249 2519"
                                        ></polygon>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                              ) : (
                                <svg
                                  width="24"
                                  height="26"
                                  viewBox="-6 -2 22 22"
                                  version="1.1"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="Page-1"
                                    stroke="none"
                                    strokeWidth="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                  >
                                    <g
                                      id="Dribbble-Light-Preview"
                                      transform="translate(-305.000000, -2679.000000)"
                                      strokeWidth="2"
                                      stroke="black"
                                      fill="none"
                                    >
                                      <g
                                        id="icons"
                                        transform="translate(56.000000, 160.000000)"
                                      >
                                        <polygon
                                          id="bookmark_fill-[#1226]"
                                          points="259 2519 259 2539 254 2534 249 2539 249 2519"
                                        ></polygon>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                              )}
                              Bookmark
                            </button>
                          </div>
                          <div className="list-drop">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                                fill="black"
                              />
                            </svg>{" "}
                            Save to Wishlist
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  )}
                </div>
              </div>:<></>}
            </div>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <BreadCrumbComponent crumbList={breadCrumbData} />
                </div>
                <div className="col-md-8">
                  <div className="module-learn-text mt-0">
                    {isLoading ? (
                      <div className="mgt30">
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"50px"}
                        />
                      </div>
                    ) : (
                      <h2 className="mgt30">{title}</h2>
                    )}

                    {isLoading ? (
                      <ul className="learncourselistt-row mt-3 mb-3">
                        <li>
                          <ShimmerScreen
                            case={"rect"}
                            width={"80px"}
                            height={"25px"}
                          />
                        </li>
                        <li>
                          <ShimmerScreen
                            case={"rect"}
                            width={"80px"}
                            height={"25px"}
                          />
                        </li>
                      </ul>
                    ) : (
                      coachingDetailData && (
                        <div className="d-flex box-meta">
                          <div className="img-box-meta">
                            <img
                              src={
                                coachingDetailData.provider
                                  ? coachingDetailData.provider.provider_img
                                  : ""
                              }
                            />
                          </div>
                          <div className="meta-lsit">
                            <ul className="learncourselistt-row">
                              <li>
                                {coachingDetailData.provider
                                  ? coachingDetailData.provider
                                      .provider_display_name
                                  : ""}
                              </li>
                            </ul>
                          </div>
                        </div>
                      )
                    )}

                    {isLoading ? (
                      <ShimmerScreen case="rect" width="60%" height="7rem" />
                    ) : (
                      <div
                        className="details-discription"
                        dangerouslySetInnerHTML={{
                          __html: coachingDetailData?.long_description,
                        }}
                      ></div>
                    )}

                    <CartPopUpComponent
                      isOpen={isOpen}
                      productData={headerProdData}
                      closeAction={() => setIsOpen(false)}
                      isSubscription={true}
                      setMainPageLoading={setInfoModal}
                      isMobile={isMobile}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  {false && (
                    <RightPanelComponent
                      id={coachingDetailData?.product_id}
                      parentName={"service"}
                      code={coachingDetailData?.service_code}
                      moduleData={coachingDetailData}
                      type={"service"}
                      source={coachingDetailData?.source}
                      isMobile={false}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
          <div className="mt-5">
            <SimilarCoachings />
          </div>
        </Page>
      )}
      {/* <Page>
        <section className="bannersection-sec">
          <div className="bannersection">
            <div className="title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center">
              {isLoading ? (
                <ShimmerScreen case={"rect"} width={"100%"} height={"100%"} />
              ) : (
                <p
                  dangerouslySetInnerHTML={{
                    __html: title,
                  }}
                ></p>
              )}
            </div>
            <div className="bb-sec">
              <div className="container d-flex align-items-center cont-baner">
                <div className="button-box">
                  {isLoading ? (
                    ""
                  ) : (
                    <>
                      <span>{singlePriceUpcoming()}</span>
                      {coachingDetailData &&
                        !coachingDetailData?.is_paid &&
                        !coachingDetailData?.purchased_info
                          ?.part_of_subscription && (
                          <button
                            type="button"
                            className="startcourse-btn"
                            onClick={() =>
                              proceedToPurchase(
                                coachingDetailData,
                                bannerPriceInfo
                              )
                            }
                          >
                            Purchase
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#415385"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        )}
                    </>
                  )}
                </div>

                <div className="bannershare-btn">
                  <Dropdown className="customdropdown-btn">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                      >
                        <path
                          d="M30 36.6666C28.6111 36.6666 27.4306 36.1805 26.4583 35.2083C25.4861 34.236 25 33.0555 25 31.6666C25 31.4721 25.0139 31.2708 25.0417 31.0624C25.0694 30.8541 25.1111 30.6666 25.1667 30.4999L13.4167 23.6666C12.9444 24.0833 12.4167 24.4096 11.8333 24.6458C11.25 24.8819 10.6389 24.9999 10 24.9999C8.61111 24.9999 7.43056 24.5138 6.45833 23.5416C5.48611 22.5694 5 21.3888 5 19.9999C5 18.611 5.48611 17.4305 6.45833 16.4583C7.43056 15.486 8.61111 14.9999 10 14.9999C10.6389 14.9999 11.25 15.118 11.8333 15.3541C12.4167 15.5902 12.9444 15.9166 13.4167 16.3333L25.1667 9.49992C25.1111 9.33325 25.0694 9.14575 25.0417 8.93742C25.0139 8.72908 25 8.5277 25 8.33325C25 6.94436 25.4861 5.76381 26.4583 4.79159C27.4306 3.81936 28.6111 3.33325 30 3.33325C31.3889 3.33325 32.5694 3.81936 33.5417 4.79159C34.5139 5.76381 35 6.94436 35 8.33325C35 9.72214 34.5139 10.9027 33.5417 11.8749C32.5694 12.8471 31.3889 13.3333 30 13.3333C29.3611 13.3333 28.75 13.2152 28.1667 12.9791C27.5833 12.743 27.0556 12.4166 26.5833 11.9999L14.8333 18.8333C14.8889 18.9999 14.9306 19.1874 14.9583 19.3958C14.9861 19.6041 15 19.8055 15 19.9999C15 20.1944 14.9861 20.3958 14.9583 20.6041C14.9306 20.8124 14.8889 20.9999 14.8333 21.1666L26.5833 27.9999C27.0556 27.5833 27.5833 27.2569 28.1667 27.0208C28.75 26.7846 29.3611 26.6666 30 26.6666C31.3889 26.6666 32.5694 27.1527 33.5417 28.1249C34.5139 29.0971 35 30.2777 35 31.6666C35 33.0555 34.5139 34.236 33.5417 35.2083C32.5694 36.1805 31.3889 36.6666 30 36.6666ZM30 9.99992C30.4722 9.99992 30.8681 9.8402 31.1875 9.52075C31.5069 9.20131 31.6667 8.80547 31.6667 8.33325C31.6667 7.86103 31.5069 7.4652 31.1875 7.14575C30.8681 6.82631 30.4722 6.66658 30 6.66658C29.5278 6.66658 29.1319 6.82631 28.8125 7.14575C28.4931 7.4652 28.3333 7.86103 28.3333 8.33325C28.3333 8.80547 28.4931 9.20131 28.8125 9.52075C29.1319 9.8402 29.5278 9.99992 30 9.99992ZM10 21.6666C10.4722 21.6666 10.8681 21.5069 11.1875 21.1874C11.5069 20.868 11.6667 20.4721 11.6667 19.9999C11.6667 19.5277 11.5069 19.1319 11.1875 18.8124C10.8681 18.493 10.4722 18.3333 10 18.3333C9.52778 18.3333 9.13194 18.493 8.8125 18.8124C8.49306 19.1319 8.33333 19.5277 8.33333 19.9999C8.33333 20.4721 8.49306 20.868 8.8125 21.1874C9.13194 21.5069 9.52778 21.6666 10 21.6666ZM30 33.3333C30.4722 33.3333 30.8681 33.1735 31.1875 32.8541C31.5069 32.5346 31.6667 32.1388 31.6667 31.6666C31.6667 31.1944 31.5069 30.7985 31.1875 30.4791C30.8681 30.1596 30.4722 29.9999 30 29.9999C29.5278 29.9999 29.1319 30.1596 28.8125 30.4791C28.4931 30.7985 28.3333 31.1944 28.3333 31.6666C28.3333 32.1388 28.4931 32.5346 28.8125 32.8541C29.1319 33.1735 29.5278 33.3333 30 33.3333Z"
                          fill="white"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div
                        className={`list-drop reset-btn like-btn d-flex ${
                          isLikeClicked ? "active" : ""
                        }`}
                        onClick={() => postLikeDisLike()}
                      >
                        {isLikeClicked ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 512 512"
                          >
                            <path
                              fill="#ff2600"
                              d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M12 21L10.55 19.7C8.86667 18.1833 7.475 16.875 6.375 15.775C5.275 14.675 4.4 13.6875 3.75 12.8125C3.1 11.9375 2.64583 11.1333 2.3875 10.4C2.12917 9.66666 2 8.91666 2 8.14999C2 6.58333 2.525 5.27499 3.575 4.22499C4.625 3.17499 5.93333 2.64999 7.5 2.64999C8.36667 2.64999 9.19167 2.83333 9.975 3.19999C10.7583 3.56666 11.4333 4.08333 12 4.74999C12.5667 4.08333 13.2417 3.56666 14.025 3.19999C14.8083 2.83333 15.6333 2.64999 16.5 2.64999C18.0667 2.64999 19.375 3.17499 20.425 4.22499C21.475 5.27499 22 6.58333 22 8.14999C22 8.91666 21.8708 9.66666 21.6125 10.4C21.3542 11.1333 20.9 11.9375 20.25 12.8125C19.6 13.6875 18.725 14.675 17.625 15.775C16.525 16.875 15.1333 18.1833 13.45 19.7L12 21ZM12 18.3C13.6 16.8667 14.9167 15.6375 15.95 14.6125C16.9833 13.5875 17.8 12.6958 18.4 11.9375C19 11.1792 19.4167 10.5042 19.65 9.91249C19.8833 9.32083 20 8.73333 20 8.14999C20 7.14999 19.6667 6.31666 19 5.64999C18.3333 4.98333 17.5 4.64999 16.5 4.64999C15.7167 4.64999 14.9917 4.87083 14.325 5.31249C13.6583 5.75416 13.2 6.31666 12.95 6.99999H11.05C10.8 6.31666 10.3417 5.75416 9.675 5.31249C9.00833 4.87083 8.28333 4.64999 7.5 4.64999C6.5 4.64999 5.66667 4.98333 5 5.64999C4.33333 6.31666 4 7.14999 4 8.14999C4 8.73333 4.11667 9.32083 4.35 9.91249C4.58333 10.5042 5 11.1792 5.6 11.9375C6.2 12.6958 7.01667 13.5875 8.05 14.6125C9.08333 15.6375 10.4 16.8667 12 18.3Z"
                              fill="black"
                            />
                          </svg>
                        )}
                        Like
                      </div>
                      <div className="list-drop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7625 15.025 18.6375C15.0417 18.5125 15.0667 18.4 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.6458 7.1 14.7875C6.75 14.9292 6.38333 15 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.07083 7.1 9.2125C7.45 9.35417 7.76667 9.55 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.4875 15.025 5.3625C15.0083 5.2375 15 5.11667 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92917 16.9 7.7875C16.55 7.64583 16.2333 7.45 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5125 8.975 11.6375C8.99167 11.7625 9 11.8833 9 12C9 12.1167 8.99167 12.2375 8.975 12.3625C8.95833 12.4875 8.93333 12.6 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3542 16.9 16.2125C17.25 16.0708 17.6167 16 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22ZM18 6C18.2833 6 18.5208 5.90417 18.7125 5.7125C18.9042 5.52083 19 5.28333 19 5C19 4.71667 18.9042 4.47917 18.7125 4.2875C18.5208 4.09583 18.2833 4 18 4C17.7167 4 17.4792 4.09583 17.2875 4.2875C17.0958 4.47917 17 4.71667 17 5C17 5.28333 17.0958 5.52083 17.2875 5.7125C17.4792 5.90417 17.7167 6 18 6ZM6 13C6.28333 13 6.52083 12.9042 6.7125 12.7125C6.90417 12.5208 7 12.2833 7 12C7 11.7167 6.90417 11.4792 6.7125 11.2875C6.52083 11.0958 6.28333 11 6 11C5.71667 11 5.47917 11.0958 5.2875 11.2875C5.09583 11.4792 5 11.7167 5 12C5 12.2833 5.09583 12.5208 5.2875 12.7125C5.47917 12.9042 5.71667 13 6 13ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19C19 18.7167 18.9042 18.4792 18.7125 18.2875C18.5208 18.0958 18.2833 18 18 18C17.7167 18 17.4792 18.0958 17.2875 18.2875C17.0958 18.4792 17 18.7167 17 19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20Z"
                            fill="black"
                          />
                        </svg>{" "}
                        Share
                      </div>
                      <div className="">
                        <button
                          className={`list-drop reset-btn like-btn d-flex ${
                            isBookMarkClicked ? "active" : ""
                          }`}
                          onClick={() => postBookmark()}
                        >
                          {isBookMarkClicked ? (
                            <svg
                              width="24"
                              height="26"
                              viewBox="-6 -2 22 22"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                id="Page-1"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <g
                                  id="Dribbble-Light-Preview"
                                  transform="translate(-305.000000, -2679.000000)"
                                  strokeWidth="2"
                                  stroke="#ff9800"
                                  fill="#ff9800"
                                >
                                  <g
                                    id="icons"
                                    transform="translate(56.000000, 160.000000)"
                                  >
                                    <polygon
                                      id="bookmark_fill-[#1226]"
                                      points="259 2519 259 2539 254 2534 249 2539 249 2519"
                                    ></polygon>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          ) : (
                            <svg
                              width="24"
                              height="26"
                              viewBox="-6 -2 22 22"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                id="Page-1"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <g
                                  id="Dribbble-Light-Preview"
                                  transform="translate(-305.000000, -2679.000000)"
                                  strokeWidth="2"
                                  stroke="black"
                                  fill="none"
                                >
                                  <g
                                    id="icons"
                                    transform="translate(56.000000, 160.000000)"
                                  >
                                    <polygon
                                      id="bookmark_fill-[#1226]"
                                      points="259 2519 259 2539 254 2534 249 2539 249 2519"
                                    ></polygon>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          )}
                          Bookmark
                        </button>
                      </div>
                      <div className="list-drop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                            fill="black"
                          />
                        </svg>{" "}
                        Save to Learn list
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <BreadCrumbComponent crumbList={breadCrumbData} />
            <div className="row">
              <div className="col-md-8">
                <div className="module-learn-text mt-0">
                  {isLoading ? (
                    <div className="mgt30">
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"50px"}
                      />
                    </div>
                  ) : (
                    <h2 className="mgt30">{title}</h2>
                  )}

                  {isLoading ? (
                    <ul className="learncourselistt-row mt-3 mb-3">
                      <li>
                        <ShimmerScreen
                          case={"rect"}
                          width={"80px"}
                          height={"25px"}
                        />
                      </li>
                      <li>
                        <ShimmerScreen
                          case={"rect"}
                          width={"80px"}
                          height={"25px"}
                        />
                      </li>
                    </ul>
                  ) : (
                    coachingDetailData && (
                      <div className="d-flex box-meta">
                        <div className="img-box-meta">
                          <img
                            src={
                              coachingDetailData.provider
                                ? coachingDetailData.provider.provider_img
                                : ""
                            }
                          />
                        </div>
                        <div className="meta-lsit">
                          <ul className="learncourselistt-row">
                            <li>
                              {coachingDetailData.provider
                                ? coachingDetailData.provider
                                    .provider_display_name
                                : ""}
                            </li>
                          </ul>
                        </div>
                      </div>
                    )
                  )}

                  {isLoading ? (
                    <ShimmerScreen case="rect" width="60%" height="7rem" />
                  ) : (
                    <div
                      className="details-discription"
                      dangerouslySetInnerHTML={{
                        __html: coachingDetailData?.long_description,
                      }}
                    ></div>
                  )}

                  <CartPopUpComponent
                    isOpen={isOpen}
                    productData={headerProdData}
                    closeAction={() => setIsOpen(false)}
                    isSubscription={false}
                    setMainPageLoading={setInfoModal}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </Page> */}
      {/* <ConfirmModal
        confirmModal={infoModal}
        setConfirmModal={setInfoModal}
        showModalMsg={showInfoModalMsg}
        isConfirm={isConfirm}
        confirmId={""}
        confirmAction={() => {}}
        isRightIcon={!isConfirm}
      /> */}
    </>
  );
}

export default CoachingDetailPage;
